import { RECEIVE_TAX_RETURN_POTENTIAL_DEDUCTIONS, REQUEST_TAX_RETURN_POTENTIAL_DEDUCTIONS } from '../actions'

export default (
    state = {
        fetchSuccessful: null,
        isFetching: false,
        items: [],
        shouldFetch: true,
    },
    action
) => {
    const { type, data } = action

    switch (type) {
        case REQUEST_TAX_RETURN_POTENTIAL_DEDUCTIONS:
            return { ...state, isFetching: true, shouldFetch: false }

        case RECEIVE_TAX_RETURN_POTENTIAL_DEDUCTIONS: {
            const { deductions, ...rest } = data
            return { ...state, ...rest, items: deductions || [], isFetching: false }
        }

        default:
            return state
    }
}
